import * as React from 'react';
import { getConfig } from '../../helpers';
import CustomLink from '../_common/custom-link';
import './product-preview-section.style.scss';

const Carousel = React.lazy(() => import('../_common/carousel'));

export default function ProductPreviewSection(props: ProductPreviewSectionProps) {
    const { title, description, linkUrl, linkText, children, productPreviewSectionConfig = getConfig('components.product-preview-section') } = props;

    return (
        <section className="product-preview-section page-section">
            <div className="product-preview-section__inner page-section__inner">
                <div className="product-preview-section__intro">
                    <div>
                        <h2>{title}</h2>
                        <p className="p--large">{description}</p>
                    </div>
                    <CustomLink url={linkUrl} text={linkText} linkTheme="alternative" hasIcon isUpperCase />
                </div>
                <div className="product-preview-section__preview">
                    <Carousel carouselSettings={productPreviewSectionConfig.carouselOptions}>{children}</Carousel>
                </div>
            </div>
        </section>
    );
}
